(ns dre.pages.search.views.layouts
  (:require
   [re-frame.core :as rf]))

(def layout-0-no-widget
  {:cols 24
   :breakpoint 0
   :layout
   [{:i "items", :x 0, :y 0, :w 24, :h 3 :minW 24}
    ]})

(def layout-0
  {:cols 24
   :breakpoint 0
   :layout
   [{:i "items", :x 0, :y 0, :w 24, :h 3 :minW 24}
    {:i "data-sources", :x 0, :y 4, :w 24, :h 1 :minW 24}
    {:i "publication-type", :x 0, :y 5, :w 24, :h 1 :minW 24}
    {:i "top-terms", :x 0, :y 6, :w 24, :h 1 :minW 24}
    {:i "outcomes", :x 0, :y 7, :w 24, :h 1 :minW 24}
    {:i "clinical-studies", :x 0, :y 7, :w 24, :h 1 :minW 24}
    {:i "geography", :x 0, :y 7, :w 24, :h 1 :minW 24}
    {:i "interventions", :x 0, :y 7 :w 24, :h 1 :minW 24}
    {:i "authors", :x 0, :y 7, :w 24, :h 1 :minW 24}
    {:i "related-concepts", :x 0, :y 0, :w 24, :h 1 :minW 24}
    {:i "demographics", :x 0, :y 0, :w 24, :h 1 :minW 24}
    {:i "dates", :x 0, :y 0, :w 24, :h 1 :minW 24}
    {:i "characteristics", :x 0, :y 0, :w 24, :h 1 :minW 24}
    {:i "cooccurrences-matrix", :x 0, :y 0, :w 24, :h 1 :minW 24}
    {:i "burden-of-disease", :x 0, :y 0, :w 24, :h 1 :minW 24}
    {:i "question-answering", :x 0, :y 0, :w 24, :h 1 :minW 24}]})

(def layout-880
  {:cols 24
   :breakpoint 880
   :layout
   [{:i "items", :x 8, :y 0, :w 16, :h 3 :minW 12}
    {:i "data-sources", :x 0, :y 0, :w 8, :h 1 :minW 8}
    {:i "publication-type", :x 0, :y 1, :w 8, :h 1 :minW 8}
    {:i "top-terms", :x 0, :y 4, :w 24, :h 1 :minW 8}
    {:i "outcomes", :x 0, :y 2, :w 8, :h 1 :minW 8}
    {:i "clinical-studies", :x 0, :y 4, :w 24, :h 1 :minW 8}
    {:i "geography", :x 0, :y 2, :w 8, :h 1 :minW 8}
    {:i "interventions", :x 0, :y 2 :w 8, :h 1 :minW 8}
    {:i "authors", :x 0, :y 5, :w 24, :h 1 :minW 8}
    {:i "related-concepts", :x 0, :y 0, :w 8, :h 1 :minW 8}
    {:i "demographics", :x 0, :y 0, :w 8, :h 1 :minW 8}
    {:i "dates", :x 0, :y 0, :w 8, :h 1 :minW 8}
    {:i "characteristics", :x 0, :y 0, :w 8, :h 1 :minW 8}
    {:i "cooccurrences-matrix", :x 0, :y 0, :w 24, :h 1 :minW 8}
    {:i "burden-of-disease", :x 0, :y 0, :w 24, :h 1 :minW 8}
    {:i "question-answering", :x 0, :y 0, :w 24, :h 1 :minW 8}]})

(def layout-1440
  {:cols 24
   :breakpoint 1440
   :layout
   [{:i "items", :x 12, :y 0, :w 12, :h 3 :minW 8}
    {:i "data-sources", :x 0, :y 0, :w 6, :h 1 :minW 6}
    {:i "publication-type", :x 6, :y 0, :w 6, :h 1 :minW 6}
    {:i "top-terms", :x 0, :y 1, :w 12, :h 1 :minW 6}
    {:i "outcomes", :x 0, :y 2, :w 6, :h 1 :minW 6}
    {:i "clinical-studies", :x 0, :y 1, :w 12, :h 1 :minW 6}
    {:i "geography", :x 0, :y 2, :w 6, :h 1 :minW 6}
    {:i "interventions", :x 0, :y 2 :w 6, :h 1 :minW 6}
    {:i "authors", :x 0, :y 2, :w 12, :h 1 :minW 6}
    {:i "related-concepts", :x 0, :y 0, :w 6, :h 1 :minW 6}
    {:i "demographics", :x 0, :y 0, :w 6, :h 1 :minW 6}
    {:i "dates", :x 0, :y 0, :w 6, :h 1 :minW 6}
    {:i "characteristics", :x 0, :y 0, :w 6, :h 1 :minW 6}
    {:i "cooccurrences-matrix", :x 0, :y 0, :w 12, :h 1 :minW 6}
    {:i "burden-of-disease", :x 0, :y 0, :w 12, :h 1 :minW 6}
    {:i "question-answering", :x 0, :y 0, :w 12, :h 1 :minW 6}]})

(defn assoc-constraints
  [layout]
  (doall (map (fn [l]
                (cond
                  (= "items" (:i l))
                  (merge {:minH 1 :maxW 24 :maxH 24 :resizeHandles [:sw :nw :se :ne]} l)
                  :else
                  (merge {:minH 1 :maxW 24 :maxH 24 :resizeHandles [:sw :nw :se :ne]} l))) layout)))

(defn ->strml
  [name {:keys [cols breakpoint layout]}]
  {:cols {name cols}
   :breakpoint {name breakpoint}
   :layout {name (assoc-constraints layout)}})

(def layouts-widgets
  (let [defined [["l-0" layout-0]
                 ["l-880" layout-880]
                 ["l-1440" layout-1440]]
        strml (map (fn [[n l]] (->strml n l)) defined)]
    {:cols (into {} (map :cols strml))
     :breakpoints (into {} (map :breakpoint strml))
     :layouts (into {} (map :layout strml))}))

(def layouts-no-widgets
  (let [defined [["l-0" layout-0-no-widget]]
        strml (map (fn [[n l]] (->strml n l)) defined)]
    {:cols (into {} (map :cols strml))
     :breakpoints (into {} (map :breakpoint strml))
     :layouts (into {} (map :layout strml))}))